import { render, staticRenderFns } from "./ProgramMetricWidget.vue?vue&type=template&id=1d35b84f&scoped=true&lang=pug&"
import script from "./ProgramMetricWidget.vue?vue&type=script&lang=js&"
export * from "./ProgramMetricWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProgramMetricWidget.vue?vue&type=style&index=0&id=1d35b84f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d35b84f",
  null
  
)

export default component.exports